<template>
    <div class="container mb-3">
      <div class="row mb-md-5 mt-lg-5 mt-3">
        <div class="col-md-3 col-lg-12 d-none d-sm-block" v-scroll-reveal.reset="{ delay: 250 }">
          <h3>Kategori</h3>
        </div>
        <div class="col-md-3 col-lg-3 col-sm-6 col-6 mb-4" v-scroll-reveal.reset="{ delay: 300 }">
          <div class="card hover-box-shadow">
            <div class="card-body text-center">
              <img src="assets/img/icons/app/food.svg" height="80" class="mb-3">
              <h5>Makanan (200)</h5>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-lg-3 col-sm-6 col-6" v-scroll-reveal.reset="{ delay: 350 }">
          <div class="card hover-box-shadow">
            <div class="card-body text-center">
              <img src="assets/img/icons/app/smartphone.svg" height="80" class="mb-3">
              <h5>Elektronik (0)</h5>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-lg-3 col-sm-6 col-6" v-scroll-reveal.reset="{ delay: 400 }">
          <div class="card hover-box-shadow">
            <div class="card-body text-center">
              <img src="assets/img/icons/app/fashion.svg" height="80" class="mb-3">
              <h5>Fashion (4)</h5>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-lg-3 col-sm-6 col-6" v-scroll-reveal.reset="{ delay: 450 }">
          <div class="card hover-box-shadow">
            <div class="card-body text-center">
              <img src="assets/img/icons/app/other.svg" height="80" class="mb-3">
              <h5>Lainnya (0)</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    name: 'KategoriSection'
}
</script>